export default __webpack_public_path__ + "static/media/GoalTasksIcon.07b0c5e5.png";